//@flow

import * as React from "react"

type Props = {
  children: React.ChildrenArray<React.Element<*>>
}

type State = {
  hasError: boolean
}

class SilentErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error: Error, info: any) {
    // Display fallback UI
    this.setState(() => ({ hasError: true }))
    // You can also log the error to an error reporting service
    console.log("Silent error boundary encountered error:")
    console.log(error)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div />
    }
    return this.props.children
  }
}

export default SilentErrorBoundary



// WEBPACK FOOTER //
// ./src/UI/Errors/SilentErrorBoundary.js